import { APP_INITIALIZER, EnvironmentProviders, Provider } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { loadLibraryTranslations } from './translations-loading';

export function uiTranslationsInitializer(
  translateService: TranslateService,
  httpBackend: HttpBackend,
): () => Promise<void> {
  return () =>
    loadLibraryTranslations(
      translateService,
      httpBackend,
      (lang) => `assets/ui/i18n/${lang}.json?v=${Date.now()}`,
    );
}

export function provideUiTranslations(): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: uiTranslationsInitializer,
      deps: [TranslateService, HttpBackend],
    },
  ];
}
